import axios from "axios"
import { LOCAL_TOKEN } from "../utils/storage"

export const exportReport = ({ id, data = {} }) => {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${id}/officialized/export/pdf`,
    data,
  })
}
